import {isFunction} from 'lodash';
import {Children, cloneElement, isValidElement} from 'react';

export type RenderChildren =
    React.ReactElement | React.ReactElement[] | ((props: any) => React.ReactElement) | ((props: any) => React.ReactElement[]) |
    React.ReactElement<any, string | React.JSXElementConstructor<any>> | React.ReactNode | string;

const isHTMLChild = (child: React.ReactElement<unknown, string | React.JSXElementConstructor<any>>) => typeof child?.type === 'string';

const renderFunctionOrElementChildren = (children: RenderChildren, props: any) =>
    (isFunction(children) ? children(props) : Children.map(children, (child) =>
        isValidElement(child) ? (isHTMLChild(child) ? child : cloneElement(child, props)) : null)
    ) as React.ReactElement;

export const renderUtils = {
    isHTMLChild,
    renderFunctionOrElementChildren
};
